import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Carousel } from 'primereact/carousel';
import { ProductService } from './ProductService';
        

export function ProjectBanner() {

    const [products, setProducts] = useState([]);

    
    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '1199px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '767px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];

  
    useEffect(() => {
        ProductService.getProducts().then((data) => setProducts(data));
    }, []);

    const productTemplate = (product) => {
        return (
            <div className="rc_carousel_items">
               
                   <div className='rc_carousel_items_heading'>{product.name}</div>
                   <div className='rc_carousel_items_subheading'>{product.description}</div>
                            
            </div>
        );
    };

    return <div className='banner_area rc_projects_banner'>
        <div className='slb-container-fluid'>
            <Row>          
                <Col md={12}>
                 <div className='rc_carousel_wrapper'>
            <Carousel value={products} numVisible={1} numScroll={1} autoplayInterval={3000}  responsiveOptions={responsiveOptions} itemTemplate={productTemplate} />
            </div>
                </Col>
            </Row>
        </div>
    </div>

}